import Title from 'components/landing/Title';
import missionImage from 'assets/img/gallery/GroupPrayer.JPG';

export default function TeamSection() {
    return (
        <section className="pt-20 pb-20" style={{ backgroundColor: '#f8fafc' }}>
            <div className="container max-w-7xl mx-auto px-4">
                <div className="p-6">
                    <div
                        style={{ marginTop: "2%" }}
                        className="container max-w-7xl mx-auto px-4"
                    >
                        <Title heading="Our Mission">
                            <p style={{ fontSize: 22 }}>
                                Our allegiance is first to Jesus and His gospel, and second to the
                                spiritual needs of the incarcerated. We are happy to partner with
                                any groups that share this same passion. It's not surprising that
                                God is doing a great work behind the razor wire since Jesus
                                himself had such a heart for the lost, broken, hurting, and
                                forgotten. We consider ourselves blessed to have a front row seat
                                to God's theater of grace. "Remember those who are in prison, as
                                though in prison with them…" Hebrews 13:3
                            </p>
                        </Title>
                        <div className="mt-10 flex justify-center">
                            <img
                                src={missionImage}
                                alt="Rise Up Ministry team in prayer"
                                className="w-full max-w-3xl rounded-lg shadow-xl object-cover"
                                style={{ maxHeight: 400 }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
